module.exports = __webpack_public_path__ + "static/media/Christmas on Piano_front cover.c7f26580.jpg";